// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// import { getStorage } from "firebase/storage";
//import { initializeFirestore, CACHE_SIZE_UNLIMITED } from "firebase/firestore"; // If you want to initialize firestore with non-default settings, enable this.
import { getAuth, onAuthStateChanged } from "firebase/auth";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  //databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const functions = getFunctions(app);
//connectFunctionsEmulator(functions, "localhost", 5001); // Enable this line if you want to call to the emulator instead of the actual cloud functions.

export const firestore = getFirestore(app);
//If you want to initialize firestore with non-default settings, enable this.
// const firestore = initializeFirestore(app, {
//     cacheSizeBytes: CACHE_SIZE_UNLIMITED,
// });

export const storage = getStorage();

export const auth = getAuth(app);
export default app;